import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
}));

const WhatsappSelect = ({
	selectedWhatsappIds = [],
	onChange,
	whatsApps = [],
	title = i18n.t("userModal.form.whatsapps"),
}) => {
	const classes = useStyles();

	// Id fora das opções (conexão excluída) não fica "selecionado escondido":
	// sem chip na tela, ele seguiria no onChange e voltaria no submit.
	const visibleSelectedIds = (selectedWhatsappIds || []).filter(id =>
		whatsApps.some(w => Number(w.id) === Number(id))
	);

	const handleChange = e => {
		onChange(e.target.value || []);
	};

	return (
		<div>
			<FormControl fullWidth margin="dense" variant="outlined">
				<InputLabel shrink={visibleSelectedIds.length > 0}>
					{title}
				</InputLabel>
				<Select
					label={title}
					multiple
					labelWidth={60}
					value={visibleSelectedIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={selected => (
						<div className={classes.chips}>
							{selected?.map(id => {
								const whatsapp = whatsApps.find(w => w.id === id);
								return whatsapp ? (
									<Chip
										key={id}
										variant="outlined"
										label={whatsapp.name}
										className={classes.chip}
									/>
								) : null;
							})}
						</div>
					)}
				>
					{whatsApps.map(whatsapp => (
						<MenuItem key={whatsapp.id} value={whatsapp.id}>
							{whatsapp.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default WhatsappSelect;
